﻿import config from "../config"
const baseUrl = config.base_url + "sdd_warning_param/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    list: {
        url:  baseUrl + "list",
        type: "post",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
}

